const SUPPORTED_COUNTRIES = ["CA", "US"];

const COUNTRY_FALLBACKS = {
  CA: { code2: "CA", name: "Canada" },
  US: { code2: "US", name: "United States" },
};

const getCurrencyForCountry = (countryCode) =>
  countryCode === "US" ? "USD" : "CAD";

const getCountryForCurrency = (currency) =>
  currency === "USD" ? "US" : "CA";

const isSupportedCountry = (countryCode) =>
  SUPPORTED_COUNTRIES.includes(countryCode);

const formatMoney = (amount, currency = "CAD") =>
  `${currency} $${(amount || 0).toFixed(2)}`;

export {
  SUPPORTED_COUNTRIES,
  COUNTRY_FALLBACKS,
  getCurrencyForCountry,
  getCountryForCurrency,
  isSupportedCountry,
  formatMoney,
};
